import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ModeToggle } from '@/components/mode-toggle';
import { NotificationsDropdown } from '@/components/notifications-dropdown';
import { ThemeToggle } from '@/components/theme-toggle';
import { useAuth } from '@/contexts/auth-context';
import { Menu } from 'lucide-react';
import { Logo } from '@/components/logo';

// Import navigation components
import AdminNav from '@/components/navigation/admin-nav';
import HireNav from '@/components/navigation/hire-nav';
import ProNav from '@/components/navigation/pro-nav';
import StandardNav from '@/components/navigation/standard-nav';

// Import user menu components
import { UserNav } from '@/components/user-nav';

export default function Navbar() {
  const { user, currentMode } = useAuth();

  // Render appropriate navigation based on user mode
  const renderNavigation = () => {
    if (!user) return null;

    switch (currentMode) {
      case 'admin':
        return <AdminNav />;
      case 'hire':
        return <HireNav />;
      case 'pro':
        return <ProNav />;
      default:
        return <StandardNav />;
    }
  };

  return (
    <header className="border-b bg-background z-40">
      <div className="container flex items-center justify-between h-16 px-4 md:px-6">
        <Link to="/dashboard" className="flex items-center gap-2">
          <Logo />
        </Link>
        
        {renderNavigation()}
        
        <div className="flex items-center gap-2">
          {user ? (
            <>
              <ModeToggle />
              <NotificationsDropdown />
              <UserNav />
            </>
          ) : (
            <div className="flex items-center gap-2">
              <ThemeToggle />
              <Button variant="ghost" asChild>
                <Link to="/login">Sign In</Link>
              </Button>
              <Button asChild>
                <Link to="/register">Sign Up</Link>
              </Button>
            </div>
          )}
          <Button variant="ghost" size="icon" className="md:hidden">
            <Menu className="h-5 w-5" />
            <span className="sr-only">Toggle menu</span>
          </Button>
        </div>
      </div>
    </header>
  );
}